import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormInputPassword from "../common/FormInputPassword";
import { IRootState } from "../../types/redux/IRootStore";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/hooks";
import { changeUserPasswordRedux, deleteUserSessionRedux, setUserSessions } from "../../redux/slices/auth.feature";
import { bootboxAlert } from "../common/bootboxWrapper";
import { getUserSessionsRedux } from "../../redux/slices/auth.feature";
import _ from "lodash";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { momentDtoToLocalStringByCulture } from "../../aplUtils/dateHelper";
import { useNonInitialEffect } from "../../hooks/useNonInitialEffect";
import { getExceptionText } from "../../translations/gridTranslationHelper";

const UserPassword = () => {
    const { t } = useTranslation();
    const authRedux = useSelector((state: IRootState) => state.auth);
    const userName = authRedux.userName;
    const aplSettings = AplSettingsSelector();
    const dispatch = useAppDispatch();
    const [currentPassword, setCurrentPassword] = React.useState<string>("");
    const [newPassword1, setNewPassword1] = React.useState<string>("");
    const [newPassword2, setNewPassword2] = React.useState<string>("");

    const validatePassword = () => {
        if (newPassword1.length > 0 && newPassword1 !== newPassword2) {
            return false;
        }
        if (newPassword1.length > 0 && currentPassword === newPassword1) {
            return false;
        }
        if (newPassword1.length > 0 && newPassword1.length < 8) {
            return false;
        }
        return true;
    };

    const changePasswordClick = async () => {
        dispatch(
            changeUserPasswordRedux({ currentPassword: currentPassword, newPassword1: newPassword1, newPassword2: newPassword2 }) as any
        );
    };

    useEffect(() => {
        dispatch(getUserSessionsRedux() as any);
        return () => {
            dispatch(setUserSessions([]));
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useNonInitialEffect(() => {
        if (authRedux.error) bootboxAlert(getExceptionText(authRedux.error, aplSettings.culture), () => {});
    }, [authRedux.error]);

    return (
        <React.Fragment>
            <div className="container mw-100">
                <div className="row">
                    <div className="col-6">
                        <h2>Sessions</h2>
                        <div className="row">
                            {/* <div className="col-1">#</div> */}
                            <div className="col-2">Name</div>
                            <div className="col-4">Last Used</div>
                            <div className="col-3">Last IP</div>
                            <div className="col-2">Remove</div>
                        </div>
                        {_.orderBy(authRedux.userSessions, ["addedDate"], ["asc"]).map((session, index) => (
                            <div className="row" key={index}>
                                {/* <div className="col-1">{index + 1}</div> */}
                                <div className="col-2">{session.sessionDescription}</div>
                                <div className="col-4">{momentDtoToLocalStringByCulture(session.addedDate, aplSettings.culture)}</div>
                                <div className="col-3">{session.ipAddress}</div>
                                <div className="col-2">
                                    <button
                                        className={
                                            session.sessionId === authRedux.sessionId
                                                ? "btn btn-sm btn-danger disabled"
                                                : "btn btn-sm btn-danger"
                                        }
                                        disabled={session.sessionId === authRedux.sessionId}
                                        onClick={() => {
                                            dispatch(deleteUserSessionRedux(session.sessionId) as any);
                                        }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-6">
                        <h2>{t("main.password")}</h2>

                        <input type="text" autoComplete="username" hidden={true} value={userName} onChange={() => {}}></input>

                        <label htmlFor="currentPassword">{t("main.currentPassword")}</label>
                        <FormInputPassword name="currentPassword" autoComplete="on" onChange={setCurrentPassword} value={currentPassword} />

                        <label htmlFor="currentPassword">{t("main.newPassword")}</label>
                        <FormInputPassword
                            name="newPassword1"
                            autoComplete="new-password"
                            onChange={setNewPassword1}
                            value={newPassword1}
                        />

                        <label htmlFor="currentPassword">{t("main.newPasswordRepeat")}</label>
                        <FormInputPassword
                            name="newPassword2"
                            autoComplete="new-password"
                            onChange={setNewPassword2}
                            value={newPassword2}
                            className={`${validatePassword() ? "" : "is-invalid"}`}
                        />

                        <br />
                        <button
                            disabled={!validatePassword() || newPassword1.length === 0}
                            className="btn btn-primary float-right"
                            onClick={changePasswordClick}
                        >
                            {t("main.save")}
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UserPassword;
